import { Injector, runInInjectionContext, signal } from '@angular/core';
import { IgUser } from '@core/models/ApiFields/ig-entities';
import { RelatedUsersHttpBuilder } from '@features/social-analysis/social-users/services/related-users.http';
import { UserDetailHttpBuilder } from '@features/social-analysis/social-users/services/user-detail.http';
import { PageFiltersState } from './page-filters.store';
import { BaseState } from './state.store';
import { IData } from '@core/models/IApi';

export class IgUserDetail extends BaseState {
    #userHttp!: UserDetailHttpBuilder;
    #relatedUsersHttp!: RelatedUsersHttpBuilder;

    userData = signal({
        [IgUser.getPrefixed('username')]: '',
        [IgUser.getPrefixed('image')]: '',
        [IgUser.getPrefixed('biography')]: '',
        [IgUser.getPrefixed('followers')]: '',
        [IgUser.getPrefixed('follows')]: '',
        [IgUser.getPrefixed('influencer')]: '',
        [IgUser.getPrefixed('website')]: '',
        [IgUser.getPrefixed('mediaCount')]: '',
    });
    relUsersData = signal<IData[]>([]);

    constructor(injector: Injector) {
        super();
        runInInjectionContext(injector, () => {
            this.#userHttp = new UserDetailHttpBuilder();
            this.#relatedUsersHttp = new RelatedUsersHttpBuilder();
        });
    }

    reqData(pageFilters: PageFiltersState, igAcc: string) {
        this.#userHttp.reqData(this, pageFilters, igAcc);
        this.#relatedUsersHttp.reqData(this, pageFilters, igAcc);
    }
}
